import { ProductType } from 'types/product/Product';

export const getIngredientsAccordionCopy = (productType: ProductType) =>
  productType === ProductType.skincare
    ? {
        ingredientsLinkLabel: 'Full ingredients list',
        drawerSubtitle: 'Full ingredients list',
      }
    : {
        ingredientsLinkLabel: 'View supplement label',
        drawerSubtitle: 'Supplement label',
      };
